<script setup lang="ts">
import { api } from '@/api';
import { TaskItemDto } from '@/api/generator';
import { taskTypeLabel } from './utils.ts';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageStatus from '@/components/pages/BasePage/BasePageStatus.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { routenames } from '@/router/routenames';
import { useLoading } from '@/utils/useLoading';
import { computed, onMounted } from 'vue';
import TaskForm from './components/TaskForm.vue';
import { entityNotFoundErrorHandler } from '@/errorHandling';
import { useRouter } from 'vue-router';

interface TaskDetailsViewProps {
  id: string;
}

const props = defineProps<TaskDetailsViewProps>();

const router = useRouter();

const { action: loadTask, loading } = useLoading(async () => {
  const { result } = await api.taskItemsApi.getTaskItem({ id: props.id }, [
    entityNotFoundErrorHandler(router),
  ]);

  if (result) {
    resetForm({
      values: result,
    });
  }
}, true);

onMounted(loadTask);

const {
  form: { resetForm, values },
} = useVeeForm<TaskItemDto>({
  mode: 'details',
  options: {
    keepValuesOnUnmount: true, // keepValuesOnUnmount because tabs unmount and clear values else
  },
});

const pageSubTitle = computed(() => taskTypeLabel(values.taskType));
</script>

<template>
  <BasePage :loading="loading">
    <template #title>
      <BasePageTitle :title="values.name" :subtitle="pageSubTitle" :titleId="values.iuid" />
    </template>

    <template #status>
      <BasePageStatus :entity="values" />
    </template>

    <template #actions>
      <PtwBackButton :to="{ name: routenames.tasks.overview }" />
    </template>

    <TaskForm />
  </BasePage>
</template>
